"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppControllerPasswordReset = exports.appControllerPasswordReset = exports.useAppControllerRequestPasswordReset = exports.appControllerRequestPasswordReset = exports.useAppControllerLogin = exports.appControllerLogin = void 0;
/**
 * Generated by orval v6.5.1 🍺
 * Do not edit manually.
 * Issuer I-REC API
 * Swagger documentation for the Issuer I-REC API
 * OpenAPI spec version: 0.1
 */
const react_query_1 = require("react-query");
const response_type_1 = __importDefault(require("../response-type"));
const response_type_2 = __importDefault(require("../response-type"));
const response_type_3 = __importDefault(require("../response-type"));
const appControllerLogin = (loginDataDTO) => {
    return (0, response_type_1.default)({ url: `/api/auth/login`, method: 'post',
        data: loginDataDTO
    });
};
exports.appControllerLogin = appControllerLogin;
const useAppControllerLogin = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.appControllerLogin)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useAppControllerLogin = useAppControllerLogin;
const appControllerRequestPasswordReset = (requestPasswordResetDTO) => {
    return (0, response_type_2.default)({ url: `/api/password-reset`, method: 'post',
        data: requestPasswordResetDTO
    });
};
exports.appControllerRequestPasswordReset = appControllerRequestPasswordReset;
const useAppControllerRequestPasswordReset = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.appControllerRequestPasswordReset)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useAppControllerRequestPasswordReset = useAppControllerRequestPasswordReset;
const appControllerPasswordReset = (passwordResetDTO) => {
    return (0, response_type_3.default)({ url: `/api/password-reset`, method: 'patch',
        data: passwordResetDTO
    });
};
exports.appControllerPasswordReset = appControllerPasswordReset;
const useAppControllerPasswordReset = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.appControllerPasswordReset)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useAppControllerPasswordReset = useAppControllerPasswordReset;
//# sourceMappingURL=auth.js.map